
import { defineComponent, SetupContext, getCurrentInstance, onMounted, reactive, toRefs, watch, computed, PropType } from 'vue';
import Popup from 'vant/lib/popup';

export interface PopupActionItemType {
    key?: string | number;
    desc?: string;
    iconSrc?: string;
    onClick?: () => Promise<void> | void;
    hidden?: boolean;
}

const ActionListPopup = defineComponent({
    components: {
        VanPopup: Popup,
    },
    props: {
        actionList: {
            type: Array as PropType<Array<PopupActionItemType>>,
            default: () => [],
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['onCancel'],
    setup(props, ctx: SetupContext<Array<'onCancel'>>) {
        const handleCancel = () => {
            ctx.emit('onCancel');
        };

        return {
            handleCancel,
        };
    },
});

export default ActionListPopup;
